import angular from 'angular';
import {portal} from '../../core/portal.js';
import {asset} from '../../core/service/env.js';
import templateUrl from '../../../html/payment/transactionResult.html';

angular.module('payment').directive('onswPaymentTransactionResult', ['Widget', function (Widget) {
  /**
   * @type {angular.IDirective<angular.IScope & {
   *   translateParams: {portal: string, supportEmail: string, value?: number},
   *   success: boolean;
   *   headline: string;
   *   showErrorDetails: boolean;
   *   sessionTx: any;
   *   transaction: any;
   *   errorAction: Function;
   * }>}
   */
  const directive = {
    scope: {
      transaction: '<',
      overlay: '<',
      sessionTx: '<',
      payment: '<'
    },
    templateUrl: asset(templateUrl),
    link: function (scope, element) {

      const widget = new Widget(scope, element, 'ons-form');

      scope.translateParams = {
        portal: portal.name,
        supportEmail: portal.email.support,
      };

      scope.$watch('transaction', function (t) {
        scope.success = t.code === null;
        scope.translateParams.value = t.value - 0 + t.bonus;

        if (scope.success) {
          scope.headline = 'payment.txCompleted';
          scope.showErrorDetails = false;
        } else {
          scope.showErrorDetails = t.code != 109;
          scope.headline = 'payment.' + (scope.showErrorDetails ? 'errorHeadline' : 'error.' + t.code);
        }

        element.toggleClass('success', scope.success);
        element.toggleClass('error', !scope.success);
      });

      scope.$watchGroup(['transaction', 'payment'], function (s) {
        const payment = s[1];
        if (scope.success || !payment || typeof scope.sessionTx != 'object' || scope.sessionTx.method.id != 2) return;

        payment.country = scope.sessionTx.country;
        payment.package = scope.sessionTx.package;

        function setPayment() {
          if (!payment.country) payment.country = scope.sessionTx.country;
          if (!payment.package) payment.package = scope.sessionTx.package;
          payment.method = scope.sessionTx.method;
        }

        scope.errorAction = [112, 113].includes(scope.transaction.code) ?
          () => widget.ifNotBusy(() => payment.resetVerifiedMethod(scope.transaction.method)).then(() => {
            setPayment();
            scope.$applyAsync();
          }) :
          setPayment;
      });
    }
  };

  return directive;
}]);
